/* eslint eqeqeq: off */
import React, {Component} from "react";
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import './index.css';
import Group from "../../../Components/Group";
import Grid, {GridButton, GridControls, gridDateTime} from "../../../Components/Grid";
import Resource from "../../../Resource";
import Input from "../../../Components/Control/Input";
import Notif from "../../../Components/Notif";
import Prompt from "../../../Components/Prompt";
import Perms from '../../../Perms';
import ModalProductProperties from "../ModalProductProperties";

class ModalHospitalReserveProduct extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.Perms = {
            1: { // Norm
                INSERT: Perms().BLOOD_BANK_NORM_REQUESTS.RESERVE.INSERT,
                CANCEL: Perms().BLOOD_BANK_NORM_REQUESTS.RESERVE.CANCEL
            },
            2: { // Emer
                INSERT: Perms().BLOOD_BANK_EMER_REQUESTS.RESERVE.INSERT,
                CANCEL: Perms().BLOOD_BANK_EMER_REQUESTS.RESERVE.CANCEL
            }
        };

        this.state = {
            grid: {
                defaultColDef: {
                    floatingFilter: false
                },
                statusBar: false,
                columnDefs: [{
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    cellClass: 'green'
                }, {
                    field: 'reserverFullName',
                    headerName: 'رزرو کننده',
                    headerTooltip: 'رزرو کننده'
                }, {
                    field: 'reserveCreateDateTime',
                    headerName: 'زمان رزرو',
                    headerTooltip: 'زمان رزرو',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this)
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    // hide: !Perms().BLOOD_BANK_NORM_REQUESTS.RESERVE.CANCEL,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    control: row => {
                        return <GridControls>
                            <React.Fragment>
                                {this.Perms[this.state.data?.formTypeId]?.CANCEL && <GridButton type={"button"} theme={'red'} icon={Resource.IMAGE.PACK.TRASH1.WHITE} title={'حذف رزرو'} onClick={this.cancelReserve.bind(this, row.data)}/>}
                            </React.Fragment>
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'حذف رزرو',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}" alt="">`,
                            action: this.cancelReserve.bind(this, params.node.data),
                            disabled: !this.Perms[this.state.data?.formTypeId]?.CANCEL
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'delete'} title={'حذف'}/> درصورت نیاز به حذف ناسازگاری فرآورده می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            gridContext: null,
            rowData: [],
            gridUpdated: false,
            showRemoveFilterButton: false
        };

        this.ref = {
            modal: React.createRef(),
            prompt: React.createRef(),
            modalProductProperties: React.createRef(),
            insert: React.createRef(),
            close: React.createRef(),
            grid2: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    }

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.showRemoveFilterButton !== nextState.showRemoveFilterButton ||
            state.action !== nextState.action ||
            state.data !== nextState.data ||
            state.rowData !== nextState.rowData ||
            state.grid1Context !== nextState.grid1Context ||
            state.grid2Context !== nextState.grid2Context;
    }

    render() {
        const {state, props} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalHospitalReserveProduct'}
                   size={'wide'}
                   title={'رزرو فرآورده'}
                   onClose={_ => {
                       if (this.state.gridUpdated)
                           props.onSuccess();
                   }}>
                <ModalContent>
                    <Group className={'mar-b-10'}>
                        <div className="dis-f">
                            <Input readOnly={true} className={'fb-4 fb-4x-10 fb-2x-20 pad-4'} label={'شماره پرونده'} value={state.data?.patientFileCode}/>
                            <Input readOnly={true} className={'fb-4 fb-4x-10 fb-2x-20 pad-4'} label={'نام بیمار'} value={state.data?.patientFullName}/>
                            <Input readOnly={true} className={'fb-4 fb-4x-10 fb-2x-20 pad-4'} label={'گروه خونی'} value={state.data?.patientBloodGroupStr} direction={'ltr'} align={"center"}/>
                            <Input readOnly={true} className={'fb-4 fb-4x-10 fb-2x-20 pad-4'} label={'کد ملی بیمار'} value={state.data?.patientNationalCode} direction={'ltr'} align={"center"}/>
                            <div className="dis-f fb-4 fb-4x-10" style={{flexDirection: 'column'}}>
                                <div className="flex"/>
                                <div className={'dis-f pad-4'}>
                                    <Button className={'fb-20'} refer={this.ref.insert} onClick={this.insertClickHandler.bind(this)} theme={'green'}>رزرو فرآورده</Button>
                                </div>
                            </div>
                        </div>
                    </Group>
                    <div className={'dis-f'} style={{flex: 1}}>
                        <Group className={'ModalHospitalReserveProduct-group fb-20'}>
                            <Grid refer={this.ref.grid} id={'reserveHistoryListGrid'} {...state.grid} rowData={state.rowData} onGridReady={this.gridReadyHandler.bind(this)}/>
                        </Group>
                    </div>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalProductProperties refer={this.ref.modalProductProperties}/>
        </React.Fragment>;
    }

    updateGrid() {
        const {state} = this;

        if (this.ref.grid.current)
            this.ref.grid.current.loading();

        Hospital.reserveList({patientFileCodeId: state.data?.patientFileCodeId})
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    cancelReserve(row, props = {loading: _ => null}, callback = _ => null) {
        props.loading();

        Hospital.cancelReserve({
            reserveId: row?.reserveId,
        })
            .then(_ => {
                this.setState({
                    gridUpdated: true
                });

                callback();
                props.loading(false);

                new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();

                this.updateGrid();
            })
            .catch(message => {
                props.loading(false);
                new Notif({message, theme: 'error'}).show();
            });
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    insertClickHandler() {
        this.ref.modalProductProperties.current.open({}, ModalAction.INSERT)
            .then(data => {
                const {ref, state} = this;

                this.ref.insert.current.loading();

                Hospital.reserve({
                    bloodGroupId: data?.bloodGroupId?.[0]?.id,
                    productTypeId: data?.productTypeId?.[0]?.id,
                    sectionRequestId: state.data?.sectionRequestId
                }).then(_ => {
                    new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                    ref.insert.current.loading(false);

                    this.updateGrid();
                }).catch(message => {
                    ref.insert.current.loading(false);

                    new Notif({message, theme: 'error'}).show();
                });
            })
            .catch(message => {
                new Notif({message,})
            });
    }

    open(data, action) {
        this.setState({
            data,
            action,
            gridUpdated: false
        }, _ => {
            if (this.state.gridContext) {
                this.updateGrid();
            }
        });

        this.ref.modal.current.open();
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalHospitalReserveProduct);